<div #patientInfoTarget>
    <form [formGroup]="form">
        <p-dropdown
            id="dd-patient"
            *miproLoading="!controlInitialized() || loadingPatient(); diameterPx: '30px'"
            placeholder="Select {{namingConvService.endUserSingular}}"
            [disabled]="disabled"
            [options]="patients"
            dataKey="patientId"
            [(ngModel)]="selectedPatient"
            (onChange)="onPatientSelect($event)"
            (onClick)="basicinfo.hide($event)"
            formControlName="patient"
            showClear="true"
            appendTo="body"
            [filter]="true"
            [filterFields]="['fullName','miProNumber', 'externalPatientId']"
            [virtualScroll]="false"
            [readonly]="readonly"
            [required]="required">
            <ng-template pTemplate="selectedItem">
                <ng-container *ngIf="selectedPatient">
                    <div class="flex justify-content-start align-items-center" (mouseover)="showOverlayPanel($event, patientInfoTarget)">
                        <p-progressSpinner [style]="{ width: size, height: size }" *ngIf="loadingPatientAvatar"></p-progressSpinner>
                        <img
                            *ngIf="!loadingPatientAvatar"
                            class="border-circle"
                            [style]="{ width: size, height: size }"
                            [src]="patientAvatarUrl"
                            onerror="this.src='assets/images/noavatar.png';" />
                        <div class="flex flex-column justify-content-between patients-text-overflow">
                            <span *ngIf="!slim">
                                <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label>
                            </span>
                            {{ anonymization ? selectedPatient.miProNumber : selectedPatient.fullName }}
                        </div>
                    </div>
                </ng-container>
            </ng-template>
            <ng-template let-patient pTemplate="item">
                <span>{{ anonymization ? patient.miProNumber : patient.fullName }}</span>
            </ng-template>
            <ng-template pTemplate="header" *ngIf="showAddButton">
                <div class="flex justify-content-end" [style.padding]="'0.75rem'">
                    <a (click)="showDialog = true">
                        <i class="pi pi-plus" style="cursor: pointer"></i>
                        <span style="cursor: pointer">Add</span>
                    </a>
                </div>
            </ng-template>
        </p-dropdown>
    </form>
</div>

<p-overlayPanel #basicinfo>
    <ng-template pTemplate>
        <table width="250px">
            <tr>
                <td><b>ORB Number:</b></td>
                <td>{{ selectedPatientInfo?.miProNumber }}</td>
            </tr>
            <tr *ngIf="selectedPatientInfo.externalId">
                <td><b>External ID:</b></td>
                <td>{{ selectedPatientInfo.externalId }}</td>
            </tr>
            <tr>
                <td><b>Date of Birth:</b></td>
                <td>{{ selectedPatientInfo?.dateOfBirth?.toLocaleDateString("en-GB") }}</td>
            </tr>
            <tr>
                <td><b>Address:</b></td>
                <td>{{ selectedPatientInfo?.address }}</td>
            </tr>
            <tr>
                <td><b>Phone No:</b></td>
                <td>{{ selectedPatientInfo?.phoneNumber }}</td>
            </tr>
            <tr>
                <!-- <td><b>Squad Name:</b></td> -->
                <td>
                    <b><naming-convention-label [type]="'Group'" [singular]="true"></naming-convention-label></b>
                </td>
                <td>{{ selectedPatientInfo?.squadName }}</td>
            </tr>
            <tr>
                <td><b>User Type:</b></td>
                <td>{{ selectedPatientInfo?.userType }}</td>
            </tr>
        </table>
    </ng-template>
</p-overlayPanel>

<create-player-dialog [(visible)]="showDialog" (playerCreated)="patientCreated($event)"></create-player-dialog>
